import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import navigationReducers from "./reducers/navigationReducers";
import clientReducers from "./reducers/clientReducers";
import sectorWorkflowReducers, { initialSectorWorkflow } from "./reducers/sectorWorkflowReducers";
import eventSchedulerReducers from "./reducers/eventSchedulerReducers";
import quoteReducers from "./reducers/quoteCreateReducers";

const initialState = {
  stepQuote: "sector",
  clientSelection: null,
  alias: "",
  description: "",
  sectorWorkflow: { ...initialSectorWorkflow },
  eventScheduler: {},
  isEditingAdvancedListItem: false,
};

const quoteCreateSlice = createSlice({
  name: "quoteCreate",
  initialState,
  reducers: {
    ...navigationReducers,
    ...clientReducers,
    ...sectorWorkflowReducers,
    ...eventSchedulerReducers,
    ...quoteReducers,

    resetQuoteCreate: () => initialState,

    setAlias: (state, action: PayloadAction<string>) => {
      state.alias = action.payload;
    },

    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },

    updateServiceNameOverride: (state, action: PayloadAction<string>) => {
      state.sectorWorkflow.serviceNameOverride = action.payload;
    },
  },
});

export const quoteCreateActions = quoteCreateSlice.actions;
export default quoteCreateSlice.reducer;
